import * as React from 'react';

import { cn } from '@/lib/utils';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'border-input file:text-foreground focus-visible:ring-ring flex h-11 w-full rounded-md border bg-transparent px-3 py-1 text-base font-medium transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:font-semibold placeholder:text-black/50 focus-visible:ring-1 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-base',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
